import { Result } from "antd";
import { FC } from "react";

export const ErrorFallback: FC = () => {
  return <Result status="500" title="Sorry" subTitle="something went wrong." />;
};
